require('./ChatStatus.scss');
const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');
//@constants
const {
    CHAT_CONVERSATION_STATUS: {
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    }
} = require('constants/chat');

const ChatStatus = props => {
    const { conversationStatus, isChatAvailable, msgReceiveFail, timer, disconnectedNotice, participantJoined } = props;
    let chatStatusClasses;
    chatStatusClasses = classNames(
        'chat-status',
        {
           [`chat-status--unavailable`]: !isChatAvailable,
           [`chat-status--${ACTIVE.toLowerCase()}`]: participantJoined,
           [`chat-status--${INACTIVE.toLowerCase()}`]: (conversationStatus === INACTIVE && isChatAvailable) || !participantJoined || conversationStatus === CONNECTING,
           [`chat-status--${DISCONNECTED.toLowerCase()}`]: (msgReceiveFail && timer) || disconnectedNotice || conversationStatus === DISCONNECTED,
           [`chat-status--${ERROR.toLowerCase()}`]: conversationStatus === ERROR
       }
    )
    return (<i className={chatStatusClasses} />);
};

ChatStatus.propTypes = {
    conversationStatus: PropTypes.oneOf([
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    ]).isRequired,
    disconnectedNotice: PropTypes.bool,
    isChatAvailable: PropTypes.bool,
    msgReceiveFail: PropTypes.bool,
    participantJoined: PropTypes.bool,
    timer: PropTypes.bool
}

module.exports = ChatStatus;
